module.exports = __webpack_public_path__ + "b2f6ee80349d3109638688b6c8320362.svg";